export default "__VITE_ASSET__d8xK7Yr1__"